const defaultState: any = [];

const categoriesReducer = (state = defaultState, action: { type: string; payload: any }) => {
	switch (action.type) {
		case 'SET_CATEGORIES':
			return action.payload;

		default:
			return state;
	}
};

export default categoriesReducer;
